<h2 mat-dialog-title>Create Review Set</h2>
<mat-dialog-content style="margin-top: 8px;">
  <form [formGroup]="newReviewSetForm">
    <mat-form-field appearance="fill" style="width:100%">
      <mat-label>Review Set Name</mat-label>
      <input matInput placeholder="Enter the name for the review set" formControlName="reviewSetName" />
      <mat-error *ngIf="newReviewSetForm.controls['reviewSetName'].invalid && (newReviewSetForm.controls['reviewSetName'].touched || newReviewSetForm.controls['reviewSetName'].dirty)">
        <p *ngIf="newReviewSetForm.controls['reviewSetName'].errors.required">Review Set name is <strong>required</strong></p>
      </mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="reviewSet?.status === 'pre-review' || mode === 'creating'" appearance="fill" style="width:100%">
      <mat-label>Review Order</mat-label>
      <mat-select formControlName="reviewOrder">
        <mat-option value="master-date">Master Date</mat-option>
        <mat-option value="source-file-path">Source File Path</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button *ngIf="mode === 'editing'" mat-raised-button color="primary" id="submitSaveReviewSetFormButton" [disabled]="!newReviewSetForm.valid" (click)="saveReviewSet()">Save</button>
  <button *ngIf="mode === 'creating'" mat-raised-button color="primary" id="submitNewReviewSetFormButton" [disabled]="!newReviewSetForm.valid" (click)="addNewReviewBatch()">Create Review Set</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
